export default __webpack_public_path__ + "static/media/django.8e779b56.svg";